export const bookingNumber = {
  "booking-number": {
    shape:
      '   <path fill="#000" fill-opacity=".51" d="M4.125 20.5c-.45 0-.833-.158-1.15-.475a1.566 1.566 0 0 1-.475-1.15V4.2l1.175 1.175L5.325 3.7 7 5.375 8.675 3.7l1.65 1.675L12 3.7l1.675 1.675 1.65-1.675L17 5.375 18.675 3.7l1.65 1.675L21.5 4.2v14.675c0 .45-.158.834-.475 1.15-.317.317-.7.475-1.15.475H4.125Zm0-1H11.5v-7h-8v6.375a.61.61 0 0 0 .175.45.609.609 0 0 0 .45.175Zm8.375 0h7.375a.61.61 0 0 0 .45-.175.61.61 0 0 0 .175-.45V16.5h-8v3Zm0-4h8v-3h-8v3Zm-9-4h17V7.3h-17v4.2Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
